/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  MatchRequest,
  MatchRequestCreateRequest,
  MatchRequestsMyRequestsRetrieveParams,
  MatchRequestsOpportunitiesListParams,
  MatchRequestsResultsRetrieveParams,
  MatchRequestsTotalMatchResultsExportRetrieveParams,
  MatchRequestsTotalMatchResultsRetrieve200,
  MatchRequestsTotalMatchResultsRetrieveParams,
  Opportunity,
  OpportunityDeclineRequest,
  PaginatedMatchRequest,
  PaginatedMatchResult,
  PaginatedOpportunity,
  PatchedMatchRequestCreateRequest
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Get a specific match request by ID
 * @summary Get match request by ID
 */
export const matchRequestsDetailRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MatchRequest>(
      {url: `/api/v1/matchRequests/${id}/detail/`, method: 'GET', signal
    },
      );
    }
  

export const getMatchRequestsDetailRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/matchRequests/${id}/detail/`] as const;
    }

    
export const getMatchRequestsDetailRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof matchRequestsDetailRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsDetailRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMatchRequestsDetailRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof matchRequestsDetailRetrieve>>> = ({ signal }) => matchRequestsDetailRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof matchRequestsDetailRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type MatchRequestsDetailRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof matchRequestsDetailRetrieve>>>
export type MatchRequestsDetailRetrieveQueryError = void

/**
 * @summary Get match request by ID
 */
export const useMatchRequestsDetailRetrieve = <TData = Awaited<ReturnType<typeof matchRequestsDetailRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsDetailRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMatchRequestsDetailRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get all match results for a specific match request, sorted by Win-Win Match Score (highest first). Paginated.
 * @summary Get match results for a request
 */
export const matchRequestsResultsRetrieve = (
    id: number,
    params?: MatchRequestsResultsRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedMatchResult>(
      {url: `/api/v1/matchRequests/${id}/results/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getMatchRequestsResultsRetrieveQueryKey = (id: number,
    params?: MatchRequestsResultsRetrieveParams,) => {
    return [`/api/v1/matchRequests/${id}/results/`, ...(params ? [params]: [])] as const;
    }

    
export const getMatchRequestsResultsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof matchRequestsResultsRetrieve>>, TError = void>(id: number,
    params?: MatchRequestsResultsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsResultsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMatchRequestsResultsRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof matchRequestsResultsRetrieve>>> = ({ signal }) => matchRequestsResultsRetrieve(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof matchRequestsResultsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type MatchRequestsResultsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof matchRequestsResultsRetrieve>>>
export type MatchRequestsResultsRetrieveQueryError = void

/**
 * @summary Get match results for a request
 */
export const useMatchRequestsResultsRetrieve = <TData = Awaited<ReturnType<typeof matchRequestsResultsRetrieve>>, TError = void>(
 id: number,
    params?: MatchRequestsResultsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsResultsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMatchRequestsResultsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Re-run matching for a request whose last run failed (status `failed`, e.g. the product index was unavailable). Owner only. Returns the request: `completed` with results, or `failed` again if matching still can't run.
 * @summary Retry a failed match request
 */
export const matchRequestsRetryCreate = (
    id: number,
 ) => {
      
      
      return customInstance<MatchRequest>(
      {url: `/api/v1/matchRequests/${id}/retry/`, method: 'POST'
    },
      );
    }
  


export const getMatchRequestsRetryCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsRetryCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof matchRequestsRetryCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchRequestsRetryCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  matchRequestsRetryCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MatchRequestsRetryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof matchRequestsRetryCreate>>>
    
    export type MatchRequestsRetryCreateMutationError = void

    /**
 * @summary Retry a failed match request
 */
export const useMatchRequestsRetryCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsRetryCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof matchRequestsRetryCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getMatchRequestsRetryCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Turn a draft match request into an active one by generating matches (deals). Only the owner can start a draft. If matches already exist, this is a no-op.
 * @summary Start a draft match request (generate matches)
 */
export const matchRequestsStartCreate = (
    id: number,
 ) => {
      
      
      return customInstance<MatchRequest>(
      {url: `/api/v1/matchRequests/${id}/start/`, method: 'POST'
    },
      );
    }
  


export const getMatchRequestsStartCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsStartCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof matchRequestsStartCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchRequestsStartCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  matchRequestsStartCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MatchRequestsStartCreateMutationResult = NonNullable<Awaited<ReturnType<typeof matchRequestsStartCreate>>>
    
    export type MatchRequestsStartCreateMutationError = void

    /**
 * @summary Start a draft match request (generate matches)
 */
export const useMatchRequestsStartCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsStartCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof matchRequestsStartCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getMatchRequestsStartCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Update a draft match request. Only the owner can update and only while `isDraft=true`.
With `isDraft=false` the edits are saved and the request is started exactly like `POST /matchRequests/{id}/start/` (readiness check, charge, matching); otherwise no matches are generated.
 * @summary Update draft match request
 */
export const matchRequestsUpdateDraftUpdate = (
    id: number,
    matchRequestCreateRequest: MatchRequestCreateRequest,
 ) => {
      
      
      return customInstance<MatchRequest>(
      {url: `/api/v1/matchRequests/${id}/updateDraft/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: matchRequestCreateRequest
    },
      );
    }
  


export const getMatchRequestsUpdateDraftUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsUpdateDraftUpdate>>, TError,{id: number;data: MatchRequestCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof matchRequestsUpdateDraftUpdate>>, TError,{id: number;data: MatchRequestCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchRequestsUpdateDraftUpdate>>, {id: number;data: MatchRequestCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  matchRequestsUpdateDraftUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MatchRequestsUpdateDraftUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof matchRequestsUpdateDraftUpdate>>>
    export type MatchRequestsUpdateDraftUpdateMutationBody = MatchRequestCreateRequest
    export type MatchRequestsUpdateDraftUpdateMutationError = void

    /**
 * @summary Update draft match request
 */
export const useMatchRequestsUpdateDraftUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsUpdateDraftUpdate>>, TError,{id: number;data: MatchRequestCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof matchRequestsUpdateDraftUpdate>>,
        TError,
        {id: number;data: MatchRequestCreateRequest},
        TContext
      > => {

      const mutationOptions = getMatchRequestsUpdateDraftUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Update a draft match request. Only the owner can update and only while `isDraft=true`.
With `isDraft=false` the edits are saved and the request is started exactly like `POST /matchRequests/{id}/start/` (readiness check, charge, matching); otherwise no matches are generated.
 * @summary Update draft match request
 */
export const matchRequestsUpdateDraftPartialUpdate = (
    id: number,
    patchedMatchRequestCreateRequest: PatchedMatchRequestCreateRequest,
 ) => {
      
      
      return customInstance<MatchRequest>(
      {url: `/api/v1/matchRequests/${id}/updateDraft/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedMatchRequestCreateRequest
    },
      );
    }
  


export const getMatchRequestsUpdateDraftPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsUpdateDraftPartialUpdate>>, TError,{id: number;data: PatchedMatchRequestCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof matchRequestsUpdateDraftPartialUpdate>>, TError,{id: number;data: PatchedMatchRequestCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchRequestsUpdateDraftPartialUpdate>>, {id: number;data: PatchedMatchRequestCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  matchRequestsUpdateDraftPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MatchRequestsUpdateDraftPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof matchRequestsUpdateDraftPartialUpdate>>>
    export type MatchRequestsUpdateDraftPartialUpdateMutationBody = PatchedMatchRequestCreateRequest
    export type MatchRequestsUpdateDraftPartialUpdateMutationError = void

    /**
 * @summary Update draft match request
 */
export const useMatchRequestsUpdateDraftPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsUpdateDraftPartialUpdate>>, TError,{id: number;data: PatchedMatchRequestCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof matchRequestsUpdateDraftPartialUpdate>>,
        TError,
        {id: number;data: PatchedMatchRequestCreateRequest},
        TContext
      > => {

      const mutationOptions = getMatchRequestsUpdateDraftPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create a new match request. Company is automatically set from the authenticated user's owned company.

- If `isDraft=true`, request is stored as draft and **no matches are generated**.
- If `isDraft=false` or omitted, matches (deals) are generated immediately.
 * @summary Create match request
 */
export const matchRequestsCreateCreate = (
    matchRequestCreateRequest: MatchRequestCreateRequest,
 ) => {
      
      
      return customInstance<MatchRequest>(
      {url: `/api/v1/matchRequests/create/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: matchRequestCreateRequest
    },
      );
    }
  


export const getMatchRequestsCreateCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsCreateCreate>>, TError,{data: MatchRequestCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof matchRequestsCreateCreate>>, TError,{data: MatchRequestCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchRequestsCreateCreate>>, {data: MatchRequestCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  matchRequestsCreateCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MatchRequestsCreateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof matchRequestsCreateCreate>>>
    export type MatchRequestsCreateCreateMutationBody = MatchRequestCreateRequest
    export type MatchRequestsCreateCreateMutationError = void

    /**
 * @summary Create match request
 */
export const useMatchRequestsCreateCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsCreateCreate>>, TError,{data: MatchRequestCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof matchRequestsCreateCreate>>,
        TError,
        {data: MatchRequestCreateRequest},
        TContext
      > => {

      const mutationOptions = getMatchRequestsCreateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get all match requests created by the current user. Paginated.
 * @summary Get my match requests
 */
export const matchRequestsMyRequestsRetrieve = (
    params?: MatchRequestsMyRequestsRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedMatchRequest>(
      {url: `/api/v1/matchRequests/myRequests/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getMatchRequestsMyRequestsRetrieveQueryKey = (params?: MatchRequestsMyRequestsRetrieveParams,) => {
    return [`/api/v1/matchRequests/myRequests/`, ...(params ? [params]: [])] as const;
    }

    
export const getMatchRequestsMyRequestsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof matchRequestsMyRequestsRetrieve>>, TError = unknown>(params?: MatchRequestsMyRequestsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsMyRequestsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMatchRequestsMyRequestsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof matchRequestsMyRequestsRetrieve>>> = ({ signal }) => matchRequestsMyRequestsRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof matchRequestsMyRequestsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type MatchRequestsMyRequestsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof matchRequestsMyRequestsRetrieve>>>
export type MatchRequestsMyRequestsRetrieveQueryError = unknown

/**
 * @summary Get my match requests
 */
export const useMatchRequestsMyRequestsRetrieve = <TData = Awaited<ReturnType<typeof matchRequestsMyRequestsRetrieve>>, TError = unknown>(
 params?: MatchRequestsMyRequestsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsMyRequestsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMatchRequestsMyRequestsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Deals where the caller's company is the MATCHED supplier, newest first, with a summary of the buyer's request and the consent state. Optional `consentStatus` filter. Paginated.
 * @summary List my opportunities (supplier side)
 */
export const matchRequestsOpportunitiesList = (
    params?: MatchRequestsOpportunitiesListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedOpportunity>(
      {url: `/api/v1/matchRequests/opportunities/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getMatchRequestsOpportunitiesListQueryKey = (params?: MatchRequestsOpportunitiesListParams,) => {
    return [`/api/v1/matchRequests/opportunities/`, ...(params ? [params]: [])] as const;
    }

    
export const getMatchRequestsOpportunitiesListQueryOptions = <TData = Awaited<ReturnType<typeof matchRequestsOpportunitiesList>>, TError = unknown>(params?: MatchRequestsOpportunitiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMatchRequestsOpportunitiesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof matchRequestsOpportunitiesList>>> = ({ signal }) => matchRequestsOpportunitiesList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesList>>, TError, TData> & { queryKey: QueryKey }
}

export type MatchRequestsOpportunitiesListQueryResult = NonNullable<Awaited<ReturnType<typeof matchRequestsOpportunitiesList>>>
export type MatchRequestsOpportunitiesListQueryError = unknown

/**
 * @summary List my opportunities (supplier side)
 */
export const useMatchRequestsOpportunitiesList = <TData = Awaited<ReturnType<typeof matchRequestsOpportunitiesList>>, TError = unknown>(
 params?: MatchRequestsOpportunitiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMatchRequestsOpportunitiesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get an opportunity (supplier side)
 */
export const matchRequestsOpportunitiesRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Opportunity>(
      {url: `/api/v1/matchRequests/opportunities/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getMatchRequestsOpportunitiesRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/matchRequests/opportunities/${id}/`] as const;
    }

    
export const getMatchRequestsOpportunitiesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof matchRequestsOpportunitiesRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMatchRequestsOpportunitiesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof matchRequestsOpportunitiesRetrieve>>> = ({ signal }) => matchRequestsOpportunitiesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type MatchRequestsOpportunitiesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof matchRequestsOpportunitiesRetrieve>>>
export type MatchRequestsOpportunitiesRetrieveQueryError = void

/**
 * @summary Get an opportunity (supplier side)
 */
export const useMatchRequestsOpportunitiesRetrieve = <TData = Awaited<ReturnType<typeof matchRequestsOpportunitiesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMatchRequestsOpportunitiesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Consent to the match. Chat with the buyer opens and the buyer is notified. The answer is final.
 * @summary Accept an opportunity (supplier side)
 */
export const matchRequestsOpportunitiesAcceptCreate = (
    id: number,
 ) => {
      
      
      return customInstance<Opportunity>(
      {url: `/api/v1/matchRequests/opportunities/${id}/accept/`, method: 'POST'
    },
      );
    }
  


export const getMatchRequestsOpportunitiesAcceptCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesAcceptCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesAcceptCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchRequestsOpportunitiesAcceptCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  matchRequestsOpportunitiesAcceptCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MatchRequestsOpportunitiesAcceptCreateMutationResult = NonNullable<Awaited<ReturnType<typeof matchRequestsOpportunitiesAcceptCreate>>>
    
    export type MatchRequestsOpportunitiesAcceptCreateMutationError = void

    /**
 * @summary Accept an opportunity (supplier side)
 */
export const useMatchRequestsOpportunitiesAcceptCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesAcceptCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof matchRequestsOpportunitiesAcceptCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getMatchRequestsOpportunitiesAcceptCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Decline the match with an optional reason (seen by MatchPoint moderators only, not the buyer). The buyer is notified. Final.
 * @summary Decline an opportunity (supplier side)
 */
export const matchRequestsOpportunitiesDeclineCreate = (
    id: number,
    opportunityDeclineRequest: OpportunityDeclineRequest,
 ) => {
      
      
      return customInstance<Opportunity>(
      {url: `/api/v1/matchRequests/opportunities/${id}/decline/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: opportunityDeclineRequest
    },
      );
    }
  


export const getMatchRequestsOpportunitiesDeclineCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesDeclineCreate>>, TError,{id: number;data: OpportunityDeclineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesDeclineCreate>>, TError,{id: number;data: OpportunityDeclineRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchRequestsOpportunitiesDeclineCreate>>, {id: number;data: OpportunityDeclineRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  matchRequestsOpportunitiesDeclineCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MatchRequestsOpportunitiesDeclineCreateMutationResult = NonNullable<Awaited<ReturnType<typeof matchRequestsOpportunitiesDeclineCreate>>>
    export type MatchRequestsOpportunitiesDeclineCreateMutationBody = OpportunityDeclineRequest
    export type MatchRequestsOpportunitiesDeclineCreateMutationError = void

    /**
 * @summary Decline an opportunity (supplier side)
 */
export const useMatchRequestsOpportunitiesDeclineCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRequestsOpportunitiesDeclineCreate>>, TError,{id: number;data: OpportunityDeclineRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof matchRequestsOpportunitiesDeclineCreate>>,
        TError,
        {id: number;data: OpportunityDeclineRequest},
        TContext
      > => {

      const mutationOptions = getMatchRequestsOpportunitiesDeclineCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 
        Get all match requests with their results in an aggregated view.
        Each request includes full details and its match results sorted by Win-Win Match Score. Paginated.
        
 * @summary Get total match results (aggregated)
 */
export const matchRequestsTotalMatchResultsRetrieve = (
    params?: MatchRequestsTotalMatchResultsRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MatchRequestsTotalMatchResultsRetrieve200>(
      {url: `/api/v1/matchRequests/totalMatchResults/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getMatchRequestsTotalMatchResultsRetrieveQueryKey = (params?: MatchRequestsTotalMatchResultsRetrieveParams,) => {
    return [`/api/v1/matchRequests/totalMatchResults/`, ...(params ? [params]: [])] as const;
    }

    
export const getMatchRequestsTotalMatchResultsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof matchRequestsTotalMatchResultsRetrieve>>, TError = void>(params?: MatchRequestsTotalMatchResultsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsTotalMatchResultsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMatchRequestsTotalMatchResultsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof matchRequestsTotalMatchResultsRetrieve>>> = ({ signal }) => matchRequestsTotalMatchResultsRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof matchRequestsTotalMatchResultsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type MatchRequestsTotalMatchResultsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof matchRequestsTotalMatchResultsRetrieve>>>
export type MatchRequestsTotalMatchResultsRetrieveQueryError = void

/**
 * @summary Get total match results (aggregated)
 */
export const useMatchRequestsTotalMatchResultsRetrieve = <TData = Awaited<ReturnType<typeof matchRequestsTotalMatchResultsRetrieve>>, TError = void>(
 params?: MatchRequestsTotalMatchResultsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsTotalMatchResultsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMatchRequestsTotalMatchResultsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Download all match requests and their results in a flat Excel-friendly CSV.

Each row represents one deal (match result) with its parent match request fields.
Supports the same `search` filter as `totalMatchResults`.
 * @summary Download total match results as Excel (CSV)
 */
export const matchRequestsTotalMatchResultsExportRetrieve = (
    params?: MatchRequestsTotalMatchResultsExportRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/matchRequests/totalMatchResults/export/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getMatchRequestsTotalMatchResultsExportRetrieveQueryKey = (params?: MatchRequestsTotalMatchResultsExportRetrieveParams,) => {
    return [`/api/v1/matchRequests/totalMatchResults/export/`, ...(params ? [params]: [])] as const;
    }

    
export const getMatchRequestsTotalMatchResultsExportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof matchRequestsTotalMatchResultsExportRetrieve>>, TError = void>(params?: MatchRequestsTotalMatchResultsExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsTotalMatchResultsExportRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMatchRequestsTotalMatchResultsExportRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof matchRequestsTotalMatchResultsExportRetrieve>>> = ({ signal }) => matchRequestsTotalMatchResultsExportRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof matchRequestsTotalMatchResultsExportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type MatchRequestsTotalMatchResultsExportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof matchRequestsTotalMatchResultsExportRetrieve>>>
export type MatchRequestsTotalMatchResultsExportRetrieveQueryError = void

/**
 * @summary Download total match results as Excel (CSV)
 */
export const useMatchRequestsTotalMatchResultsExportRetrieve = <TData = Awaited<ReturnType<typeof matchRequestsTotalMatchResultsExportRetrieve>>, TError = void>(
 params?: MatchRequestsTotalMatchResultsExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsTotalMatchResultsExportRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMatchRequestsTotalMatchResultsExportRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



